var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23964 2.27565C6.54855 2.02852 6.59864 1.57776 6.35151 1.26885C6.10438 0.959945 5.65362 0.909861 5.34471 1.15699L2.95707 3.0671C2.64816 3.31423 2.59808 3.76499 2.84521 4.0739C3.09234 4.3828 3.54309 4.43289 3.852 4.18576L6.23964 2.27565Z",
    fill: "#24262E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6554 1.15699C18.3465 0.909861 17.8957 0.959945 17.6486 1.26885C17.4015 1.57776 17.4515 2.02852 17.7604 2.27565L20.1481 4.18576C20.457 4.43289 20.9078 4.3828 21.1549 4.0739C21.402 3.76499 21.3519 3.31423 21.043 3.0671L18.6554 1.15699Z",
    fill: "#24262E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.71632C6.32982 1.71632 1.73319 6.31295 1.73319 11.9832C1.73319 17.6534 6.32982 22.25 12 22.25C17.6703 22.25 22.2669 17.6534 22.2669 11.9832C22.2669 6.31295 17.6703 1.71632 12 1.71632ZM12.7163 8.16295C12.7163 7.76735 12.3956 7.44666 12 7.44666C11.6044 7.44666 11.2838 7.76735 11.2838 8.16295L11.2838 11.5056C11.2838 12.6924 12.2458 13.6545 13.4326 13.6545H14.8652C15.2608 13.6545 15.5815 13.3338 15.5815 12.9382C15.5815 12.5426 15.2608 12.2219 14.8652 12.2219H13.4326C13.037 12.2219 12.7163 11.9012 12.7163 11.5056V8.16295Z",
    fill: "#24262E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.43c0fb3e15c43a31def36f0125e3b370.svg";
export { ForwardRef as ReactComponent };